<template>
  <form-wizard
    :title="null"
    :subtitle="null"
    shape="square"
    finish-button-text="Submit"
    back-button-text="< Previous"
    nextButtonText="Next >"
    @on-complete="submitRating"
  >
    <!-- acara tab -->
    <tab-content title="Acara" :before-change="validateInputAcara">
      <validation-observer ref="acara" tag="form">
        <b-row>
          <b-col cols="12" class="mb-2">
            <h5 class="mb-0">
              Acara
            </h5>
            <small class="text-muted">
              Question
            </small>
          </b-col>
          <b-col md="12">
            <b-form-group label-for="event_rate">
              <template #label>
                <h4>Rating Acara</h4>
                <p>
                  Seberapa baikkah acara pada PCC ini?
                </p>
              </template>
              <b-col cols="12" class="text-center" style="font-size:1.5rem">
                {{ ratings[form.event_rate - 1] }}
              </b-col>
              <validation-provider
                #default="{ errors }"
                name="Rating Acara"
                rules="required"
              >
                <b-form-rating
                  id="event_rate"
                  variant="warning"
                  no-border
                  name="Rating Acara"
                  v-model="form.event_rate"
                  size="lg"
                />

                <small v-if="errors.length > 0" class="text-danger">
                  {{ errors[0] }}
                </small>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>
      </validation-observer>
    </tab-content>

    <tab-content title="Narasumber" :before-change="validateInputNarasumber">
      <validation-observer ref="narasumber" tag="form">
        <b-row>
          <b-col cols="12" class="mb-2">
            <h5 class="mb-0">
              Narasumber
            </h5>
            <small class="text-muted">
              Question
            </small>
          </b-col>
          <b-col md="12">
            <b-form-group label-for="event_rate">
              <template #label>
                <h4>Rating Acara</h4>
                <p>
                  Seberapa baikkah pembicara pada PCC ini?
                </p>
              </template>
              <b-col cols="12" class="text-center" style="font-size:1.5rem">
                  {{ ratings[form.speaker_rate - 1] }}
                </b-col>
              <validation-provider
                #default="{ errors }"
                name="Rating Narasumber"
                rules="required"
              >
                <b-form-rating
                  id="event_rate"
                  variant="warning"
                  no-border
                  name="Rating Narasumber"
                  v-model="form.speaker_rate"
                  size="lg"
                />

                <small v-if="errors.length > 0" class="text-danger">
                  {{ errors[0] }}
                </small>
                
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>
      </validation-observer>
    </tab-content>

    <tab-content title="Materi" :before-change="validateInputMateri">
      <validation-observer ref="materi" tag="form">
        <b-row>
          <b-col cols="12" class="mb-2">
            <h5 class="mb-0">
              Materi
            </h5>
            <small class="text-muted">
              Question
            </small>
          </b-col>
          <b-col md="12">
            <b-form-group label-for="event_rate">
              <template #label>
                <h4>Rating Materi</h4>
                <p>
                  Seberapa baikkah materi yang dibawakan pada PCC ini?
                </p>
              </template>
              <b-col cols="12" class="text-center" style="font-size:1.5rem">
                  {{ ratings[form.material_rate - 1] }}
                </b-col>
              <validation-provider
                #default="{ errors }"
                name="Rating materi"
                rules="required"
              >
                <b-form-rating
                  id="event_rate"
                  variant="warning"
                  no-border
                  name="Rating Materi"
                  v-model="form.material_rate"
                  size="lg"
                />

                <small v-if="errors.length > 0" class="text-danger">
                  {{ errors[0] }}
                </small>
                
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>
      </validation-observer>
    </tab-content>

    <tab-content title="Kritik & Saran" :before-change="validateInputCriticsm">
      <validation-observer ref="criticsm" tag="form">
        <b-row>
          <b-col cols="12" class="mb-2">
            <h5 class="mb-0">
              Kritik & Saran
            </h5>
            <small class="text-muted">
              Question
            </small>
          </b-col>
          <b-col md="12">
            <b-form-group label-for="criticsm">
              <template #label>
                <h4>Kritik</h4>
                <p>
                  Berikan kritik Anda disini
                </p>
              </template>
              <validation-provider
                #default="{ errors }"
                name="Kritik"
                rules="max:255"
              >
                <b-form-textarea
                  id="criticsm"
                  v-model="form.criticsm"
                  :state="errors.length > 0 ? false : null"
                  placeholder="Ketik kritik disini..."
                />

                <small v-if="errors.length > 0" class="text-danger">
                  {{ errors[0] }}
                </small>
              </validation-provider>
            </b-form-group>
          </b-col>
          <b-col md="12">
            <b-form-group label-for="suggestion">
              <template #label>
                <h4>Saran</h4>
                <p>
                  Berikan saran Anda disini
                </p>
              </template>
              <validation-provider
                #default="{ errors }"
                name="Saran"
                rules="max:255"
              >
                <b-form-textarea
                  id="suggestion"
                  v-model="form.suggestion"
                  :state="errors.length > 0 ? false : null"
                  placeholder="Ketik saran disini..."
                />

                <small v-if="errors.length > 0" class="text-danger">
                  {{ errors[0] }}
                </small>
              </validation-provider>
            </b-form-group>
          </b-col>
        </b-row>
      </validation-observer>
    </tab-content>
  </form-wizard>
</template>

<script>
import { FormWizard, TabContent } from 'vue-form-wizard'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import 'vue-form-wizard/dist/vue-form-wizard.min.css'
import {
  BRow,
  BCol,
  BFormGroup,
  BFormTextarea,
  BFormRating,
} from 'bootstrap-vue'
import { required, max } from '@validations'

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    FormWizard,
    TabContent,
    BRow,
    BCol,
    BFormGroup,
    ToastificationContent,
    BFormRating,
    BFormTextarea,
  },

  props: ['pccId'],

  data() {
    return {
      form: {
        event_rate: '',
        speaker_rate: '',
        material_rate: '',
        suggestion: '',
        criticsm: '',
      },
      ratings: [
        'Sangat Buruk',
        'Buruk',
        'Tidak Buruk atau Tidak Bagus',
        'Bagus',
        'Sangat Bagus',
      ],
      required,
      max,
    }
  },

  mounted(){
    let recaptchaScript = document.createElement('script')
    recaptchaScript.setAttribute('src','https://kit.fontawesome.com/eb80152815.js')
    document.head.appendChild(recaptchaScript)
  },
  methods: {
    submitRating() {
      this.$http
        .post(`/pcc/rating/${this.pccId}`, {
          ...this.form,
        })
        .then(() => {
          this.$emit('submitted')
          this.$toast({
            component: ToastificationContent,
            props: {
              title: 'Rating Submitted',
              icon: 'CheckIcon',
              variant: 'success',
            },
          })
        })
        .catch(err => {
          this.$notif('Error', `${err.message}`, 'error')
        })
    },
    validateInputAcara() {
      return new Promise((resolve, reject) => {
        this.$refs.acara.validate().then(success => {
          if (success) {
            resolve(true)
          } else {
            reject()
          }
        })
      })
    },
    validateInputNarasumber() {
      return new Promise((resolve, reject) => {
        this.$refs.narasumber.validate().then(success => {
          if (success) {
            resolve(true)
          } else {
            reject()
          }
        })
      })
    },
    validateInputMateri() {
      return new Promise((resolve, reject) => {
        this.$refs.materi.validate().then(success => {
          if (success) {
            resolve(true)
          } else {
            reject()
          }
        })
      })
    },
    validateInputCriticsm() {
      return new Promise((resolve, reject) => {
        this.$refs.criticsm.validate().then(success => {
          if (success) {
            resolve(true)
          } else {
            reject()
          }
        })
      })
    },
  },
}
</script>
<style>
.wizard-btn::after {
    display: none;
}
.wizard-btn::before {
    display: none;
}
</style>
<style lang="scss">
@import '@core/scss/vue/libs/vue-wizard.scss';
</style>
